<div class="app-container">
  <div class="header">
    <deloitteai-header [logoUrl]="logoUrl" *ngIf="!environment['hideHeader']">
    </deloitteai-header>
    <aihub-loader></aihub-loader>
  </div>
  <div class="body">
    <div class="side-menu">
      <app-side-menu-new [subscription_id]="subscription_id">
      </app-side-menu-new>
    </div>
    <div class="content-block">
      <div class="content">
        <ng-container *appDynamicLoader="appMeta"></ng-container>
      </div>
      <div class="disclaimer">
        <p>PostGenie, as a subset of AI, specifically focuses on generating new content.</p>
        <p>PostGenie can make your own work more efficient. However it may occasionally generate inaccurate information
          regarding individuals, locations, or factual details. Consequently, it is advised that all output be
          meticulously
          verified and assessed by human experts.</p>
      </div>
    </div>
  </div>
  <ng-container *ngIf="!environment['hideFooter']">
    <div class="footer">
      <deloitteai-footer></deloitteai-footer>
    </div>
  </ng-container>
</div>